if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        
        if (this.form) {
          // Supprimer l'action pour empêcher la soumission normale
          if (this.form.hasAttribute('action')) {
            this.form.removeAttribute('action');
          }
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this), { capture: true });
        }
        
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
        
        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (this.querySelector('.loading__spinner')) {
          this.querySelector('.loading__spinner').classList.remove('hidden');
        }

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        
        if (!variantId) {
          this.handleErrorMessage('Variant ID manquant');
          this.submitButton.classList.remove('loading');
          if (this.querySelector('.loading__spinner')) {
            this.querySelector('.loading__spinner').classList.add('hidden');
          }
          this.submitButton.removeAttribute('aria-disabled');
          return;
        }
        
        // Ajouter les sections à mettre à jour pour le drawer
        if (this.cart) {
          const sectionsToRender = this.cart.getSectionsToRender();
          formData.append('sections', sectionsToRender.map((section) => section.id).join(','));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        
        // Fetch vers /cart/add.js
        const cartAddUrl = routes.cart_add_url.endsWith('.js') ? routes.cart_add_url : routes.cart_add_url + '.js';
        
        fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
          },
          body: formData
        })
          .then((response) => {
            if (!response.ok) {
              return response.text().then(text => {
                try {
                  return JSON.parse(text);
                } catch (e) {
                  throw new Error('Réponse non-JSON reçue');
                }
              });
            }
            return response.json();
          })
          .then((parsedState) => {
            if (parsedState.status) {
              // Erreur lors de l'ajout
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: parsedState.errors || parsedState.description,
                message: parsedState.message,
              });
              this.handleErrorMessage(parsedState.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
              }
              return;
            }

            // Succès - publier l'événement de mise à jour du panier
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: variantId,
              cartData: parsedState,
            });
            this.error = false;
            
            // Mettre à jour le drawer (ouvre automatiquement via renderContents)
            const cartDrawer = document.querySelector('cart-drawer');
            const quickAddModal = this.closest('quick-add-modal');
            
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
                    cartDrawer.renderContents(parsedState);
                  } else if (this.cart && typeof this.cart.renderContents === 'function') {
                    this.cart.renderContents(parsedState);
                  }
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // Mettre à jour le drawer directement
              if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents(parsedState);
              } else if (this.cart && typeof this.cart.renderContents === 'function') {
                this.cart.renderContents(parsedState);
              }
            }
          })
          .catch((e) => {
            console.error('Erreur lors de l\'ajout au panier:', e);
            this.handleErrorMessage('Une erreur est survenue lors de l\'ajout au panier');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.querySelector('.loading__spinner')) {
              this.querySelector('.loading__spinner').classList.add('hidden');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
